import type { IconProps } from './types';

export const Solana = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17" fill="none" aria-hidden="true" {...props}>
    <g clipPath="url(#clip0_17328_19182)">
      <path
        d="M4.18704 12.3492c.12185-.1219.2894-.193.46709-.193H20.7687c.2944 0 .4417.3554.2335.5636l-3.1833 3.1833c-.1218.1219-.2894.1929-.4671.1929H1.23728c-.294467 0-.441702-.3554-.23354-.5635l3.1833-3.1833Z"
        fill="var(--color-quanta-icon)"
      />
      <path
        d="M4.18704.466365c.12693-.121849.29447-.192927.46709-.192927H20.7687c.2944 0 .4417.355393.2335.563551L17.8189 4.0203c-.1218.12185-.2894.19292-.4671.19292H1.23728c-.294467 0-.441702-.35539-.23354-.56355L4.18704.466365Z"
        fill="var(--color-quanta-icon)"
      />
      <path
        d="M17.8189 6.37261c-.1218-.12184-.2894-.19292-.4671-.19292H1.23728c-.294467 0-.441702.35539-.23354.56355l3.1833 3.18331c.12185.12185.2894.19295.46709.19295H20.7687c.2944 0 .4417-.35542.2335-.56358l-3.1833-3.18331Z"
        fill="var(--color-quanta-icon)"
      />
    </g>
    <defs>
      <clipPath id="clip0_17328_19182">
        <rect width="20.1914" height="15.8251" fill="var(--color-quanta-icon)" transform="translate(0.90625 0.273438)" />
      </clipPath>
    </defs>
  </svg>
);
